import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatYouAchieve() {
  const achievements = ['Elaborar minidonas dulces y saladas', 'Crear torres temáticas para cumpleaños', 'Calcular costos y ganancias', 'Publicarlas y venderlas por redes', 'Tomar pedidos personalizados', 'Recuperar tu inversión con pocas ventas'];
  return <section className="w-full bg-[#FBF5EC] donut-pattern py-4 md:py-8 relative" data-id="element-253">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-255">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3D2817] text-center mb-3 md:mb-6" data-id="element-256">
            ✨ Lo que vas a lograr
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-3" data-id="element-257">
            {achievements.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="flex items-start gap-3 bg-white border border-[#E8D5BA] rounded-lg p-3 md:p-4 shadow-sm" data-id="element-258">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#E7F2EA] flex items-center justify-center mt-0.5" data-id="element-259">
                  <CheckIcon className="w-4 h-4 text-[#5C8A6D]" data-id="element-260" />
                </span>
                <p className="text-[#3D2817] text-sm md:text-base font-medium leading-snug" data-id="element-261">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}